import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import { Button, ButtonFit, ButtonIntent } from '../Button/Button';
import { Typography } from '../Typography/Typography';
import { Chevron } from '../icons';
import { Globe } from '../icons/Globe/Globe';
import styles from './StoreSwitcherButton.module.css';

export type Props = {
  className?: string;
  iconFill?: string;
  isHeaderPart?: boolean;
  label: string | null;
  onClick?: () => void;
  textClassName?: string;
};

const messages = defineMessages({
  changeButton: {
    id: 'src.components.StoreSwitcherButton.changeButton',
    defaultMessage: 'Change',
  },
});

export const StoreSwitcherButton = React.memo((props: Props) => {
  const {
    onClick,
    label,
    className,
    textClassName,
    iconFill,
    isHeaderPart,
  } = props;

  return isHeaderPart ? (
    <Button
      onClick={onClick}
      intent={ButtonIntent.linkish}
      fit={ButtonFit.Fill}
    >
      <div className={styles.linkButton}>
        <Typography
          variant='body1'
          className={classNames(styles.text, textClassName)}
        >
          { label }
        </Typography>
        <Chevron fill={iconFill} variant='down' />
      </div>
    </Button>
  ) : (
    <Button
      className={classNames(styles.storeSwitcherButton, className)}
      intent={ButtonIntent.primary}
      onClick={onClick}
      fit={ButtonFit.Fill}
    >
      <div className={styles.storeSwitcherContent}>
        <div className={styles.storeSwitcherContentLeft}>
          <Globe
            className={styles.globeIcon}
            fill={iconFill ?? CONFIG.applicationSiteGroup === 'CB' ? '#fff' : '#0f0a1b'}
          />
          <Typography
            variant='bodySubText2'
            className={classNames(styles.text, textClassName)}
          >
            { label }
          </Typography>
        </div>
        <div className={styles.storeSwitcherContentRight}>
          <Typography
            className={classNames(styles.underline, styles.text, textClassName)}
            variant='bodySubText2'
          >
            <FormattedMessage {...messages.changeButton} />
          </Typography>
        </div>
      </div>
    </Button>
  );
});

StoreSwitcherButton.displayName = 'StoreSwitcherButton';
